export default __webpack_public_path__ + "static/media/Inter-Thin.2a24f83a.woff";